import { isFamily, ASSET_FAMILY } from '@exodus/assets';
export class ExchangeTxSimulator {
    #exchangeAssets;
    constructor(params) {
        this.#exchangeAssets = params.exchangeAssets;
    }
    simulateTx = async ({ walletAccount, txs, ...simulationTxData }) => {
        const asset = this.#exchangeAssets.getAsset({ assetName: simulationTxData.baseAssetName });
        if (!isFamily({ asset, family: ASSET_FAMILY.EVM })) {
            return asset.api.web3.simulateTransactions({
                ...simulationTxData,
                transactionBuffers: txs,
            });
        }
        return asset.api.web3.simulateTransactions({
            ...simulationTxData,
            transactions: txs,
        });
    };
}
const exchangeTxSimulatorFactory = (args) => new ExchangeTxSimulator({ ...args });
const exchangeTxSimulatorModuleDefinition = {
    id: 'exchangeTxSimulator',
    type: 'module',
    factory: exchangeTxSimulatorFactory,
    dependencies: ['exchangeAssets'],
};
export default exchangeTxSimulatorModuleDefinition;
